import styled from 'styled-components';
import { colourPalette, cssScreens, fontSize, lineHeight } from 'styles/styles';

export const LeftPanelPageBaseHeaderStyle = {
  Container: styled.div``,
  Header: styled.div`
    height: 56px;
    border-bottom: 1px solid ${colourPalette.neutral300};
    padding: 16px 24px;
    display: flex;
    align-items: center;
    @media screen and (max-width: ${cssScreens.mobileLarge}) {
      border-bottom: none;
    }
  `,
  Right: styled.div`
    flex: 1;
    text-align: end;
    font-size: ${fontSize.fontSizeSM};
    line-height: ${lineHeight.lineHeightMD};
    & > a:hover {
      text-decoration: underline;
    }
  `,
};
